import React from 'react'
import { Box, Typography } from '@mui/material'
import { Column } from 'shared/ui/Table/types'

/**
 * Creates a "Field Path" column for external URL tables.
 * Displays the field path in monospace font.
 */
export function createFieldPathColumn<
  T extends { field_path: string },
>(): Column<T> {
  return {
    title: 'Field Path',
    rowContent: ({ field_path }) => (
      <Typography variant="body2" style={{ fontFamily: 'monospace' }}>
        {field_path}
      </Typography>
    ),
  }
}

/**
 * Creates a "URLs Found" column for external URL tables.
 * Displays URLs as clickable links that open in a new tab.
 */
export function createUrlsFoundColumn<
  T extends { match_result: string[] },
>(): Column<T> {
  return {
    title: 'URLs Found',
    rowContent: ({ match_result }) => (
      <Box>
        {match_result.map((url, idx) => (
          <Box key={idx} style={{ marginBottom: '2px' }}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <Typography variant="body2" style={{ fontSize: '0.875rem' }}>
                {url}
              </Typography>
            </a>
          </Box>
        ))}
      </Box>
    ),
  }
}

/**
 * Creates a "Type" column for external URL tables.
 * Generic helper for displaying node_type or leaf_type.
 */
export function createTypeColumn<T>(
  title: string,
  accessor: (item: T) => string,
): Column<T> {
  return {
    title,
    rowContent: (item) => (
      <Typography variant="body2">{accessor(item)}</Typography>
    ),
  }
}
